import {
  FETCH_POWIATY_REQUEST,
  FETCH_POWIATY_SUCCESS,
  FETCH_POWIATY_FAILURE,
} from '../constants';

const powiatyInitialState = {
  powiaty: null,
  arePowiatyFetched: false,
  arePowiatyFetching: false,
};

const powiatyRequest = (state) => ({
  ...state,
  arePowiatyFetching: true,
});
const powiatySuccess = (state, action) => ({
  ...state,
  arePowiatyFetching: false,
  arePowiatyFetched: true,
  powiaty: action.payload,
});
const powiatyFailure = (state) => ({
  ...state,
  arePowiatyFetching: false,
  arePowiatyFetched: false,
});

export default function reducer(state = powiatyInitialState, action) {
  return ({
    [FETCH_POWIATY_REQUEST]: powiatyRequest,
    [FETCH_POWIATY_SUCCESS]: powiatySuccess,
    [FETCH_POWIATY_FAILURE]: powiatyFailure,
  }[action.type] || (s => s)) (state, action);
}



// WEBPACK FOOTER //
// src/reducers/powiaty.js